import * as _actions from './actions';
import _reducer from './reducer';
import _mentor from './model';

export const actions = _actions;
export const reducer = _reducer;
export const Mentor = _mentor;



// WEBPACK FOOTER //
// ./data/Mentor/index.js